import * as yup from 'yup';

const RatingFormValidationSchema = yup.object().shape({
  review: yup.string().max(200, 'Feedback must be max 200 characters.'),
});

export default RatingFormValidationSchema;
